import React from 'react';
import classnames from 'classnames';
import {NeuroMessage} from "@ignitesales/neuro-application";

const LandingPageSkeleton = () => {
  const componentClass = 'landingPage';
  const classes = classnames(componentClass, `${componentClass}--skeleton`);

  return (
    <div className={classes}>
      <div className={`${componentClass}__container`}>
        <NeuroMessage id="landing.title" tagName="h1"/>
        <NeuroMessage className="landingSpanText" tagName="span" id="landing.message" />
        <div className="landingPage--skeleton__bg" />
      </div>
    </div>
  );
};

export default LandingPageSkeleton;
